import axios from "axios";

const FetchApi = async (
  url,
  method,
  customOptions = {},
  customHeaders = {}
  // blob = false
) => {
  const token = localStorage.getItem("accessToken");

  try {
    const response = await axios(url, {
      ...customOptions,
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : undefined,
        ...customHeaders,
      },
      withCredentials: true,
      validateStatus: (status) => status < 500,
    });

    return {
      httpStatus: response.status,
      data: response.data,
    };

  } catch (error) {
    console.error(error);
  }
};

export default FetchApi;
